import { DatePipe, DecimalPipe } from "@angular/common";
import { Component, computed, signal } from "@angular/core";
import { Router } from "@angular/router";

type ApprovalStatus = "Pending" | "Approved" | "Rejected";
type ScheduleSubmission = {
  id: number;
  company: string;
  unit: string;
  contract: string;
  consumer: string;
  scheduleType: string;
  scheduleDate: string;
  revision: string;
  capacity: number;
  energy: number;
  submittedOn: string;
  submittedBy: string;
  status: ApprovalStatus;
};
type PendingAction = { ids: number[]; status: "Approved" | "Rejected" };

const SUBMISSIONS: ScheduleSubmission[] = [
  [
    "SunPower Energy Pvt. Ltd.",
    "SP-Unit-01 (50 MW)",
    "CTR-2026-001",
    "MSEDCL",
    "Day Ahead",
    "Revision-1",
    50,
    1020.5,
    "gc_user1",
    "Pending",
  ],
  [
    "SunPower Energy Pvt. Ltd.",
    "SP-Unit-02 (50 MW)",
    "CTR-2026-002",
    "Adani Electricity Mumbai Ltd.",
    "Day Ahead",
    "Revision-0",
    50,
    1098.8,
    "gc_user1",
    "Pending",
  ],
  [
    "WindStar Renewables Ltd.",
    "WF-Unit-01 (60 MW)",
    "CTR-2026-003",
    "MSEDCL",
    "Day Ahead",
    "Revision-1",
    60,
    1272.1,
    "gc_user2",
    "Pending",
  ],
  [
    "Green Hybrid Pvt. Ltd.",
    "GH-Unit-01 (40 MW)",
    "CTR-2026-004",
    "Tata Power Co. Ltd.",
    "Week Ahead",
    "Revision-2",
    40,
    874.5,
    "gc_user3",
    "Pending",
  ],
  [
    "Maha Wind Energy Pvt. Ltd.",
    "MW-Unit-01 (45 MW)",
    "CTR-2026-005",
    "MSEDCL",
    "Day Ahead",
    "Revision-1",
    45,
    960.2,
    "gc_user2",
    "Pending",
  ],
  [
    "SunPower Energy Pvt. Ltd.",
    "SP-Unit-01 (50 MW)",
    "CTR-2026-006",
    "Industrial Consumer Pvt. Ltd.",
    "Intra Day",
    "Revision-0",
    50,
    512.4,
    "gc_user1",
    "Pending",
  ],
  [
    "WindStar Renewables Ltd.",
    "WF-Unit-02 (60 MW)",
    "CTR-2026-007",
    "MSEDCL",
    "Day Ahead",
    "Revision-1",
    60,
    1241.3,
    "gc_user2",
    "Pending",
  ],
  [
    "Maha Wind Energy Pvt. Ltd.",
    "MW-Unit-02 (45 MW)",
    "CTR-2026-008",
    "Adani Electricity Mumbai Ltd.",
    "Week Ahead",
    "Revision-2",
    45,
    928.1,
    "gc_user3",
    "Pending",
  ],
  [
    "Green Hybrid Pvt. Ltd.",
    "GH-Unit-02 (40 MW)",
    "CTR-2026-009",
    "Tata Power Co. Ltd.",
    "Day Ahead",
    "Revision-1",
    40,
    882.3,
    "gc_user3",
    "Approved",
  ],
  [
    "SunPower Energy Pvt. Ltd.",
    "SP-Unit-02 (50 MW)",
    "CTR-2026-010",
    "MSEDCL",
    "Week Ahead",
    "Revision-1",
    50,
    1032.7,
    "gc_user1",
    "Rejected",
  ],
  [
    "WindStar Renewables Ltd.",
    "WF-Unit-01 (60 MW)",
    "CTR-2026-011",
    "MSEDCL",
    "Day Ahead",
    "Revision-0",
    60,
    1256.4,
    "gc_user2",
    "Approved",
  ],
  [
    "Green Hybrid Pvt. Ltd.",
    "GH-Unit-01 (40 MW)",
    "CTR-2026-012",
    "Tata Power Co. Ltd.",
    "Intra Day",
    "Revision-1",
    40,
    420.8,
    "gc_user3",
    "Pending",
  ],
  [
    "Maha Wind Energy Pvt. Ltd.",
    "MW-Unit-01 (45 MW)",
    "CTR-2026-013",
    "MSEDCL",
    "Day Ahead",
    "Revision-0",
    45,
    947.6,
    "gc_user2",
    "Pending",
  ],
  [
    "SunPower Energy Pvt. Ltd.",
    "SP-Unit-01 (50 MW)",
    "CTR-2026-014",
    "MSEDCL",
    "Day Ahead",
    "Revision-2",
    50,
    1048.6,
    "gc_user1",
    "Approved",
  ],
  [
    "WindStar Renewables Ltd.",
    "WF-Unit-02 (60 MW)",
    "CTR-2026-015",
    "MSEDCL",
    "Week Ahead",
    "Revision-1",
    60,
    1298.2,
    "gc_user2",
    "Rejected",
  ],
  [
    "Green Hybrid Pvt. Ltd.",
    "GH-Unit-02 (40 MW)",
    "CTR-2026-016",
    "Tata Power Co. Ltd.",
    "Day Ahead",
    "Revision-0",
    40,
    860.4,
    "gc_user3",
    "Pending",
  ],
  [
    "Maha Wind Energy Pvt. Ltd.",
    "MW-Unit-02 (45 MW)",
    "CTR-2026-017",
    "MSEDCL",
    "Intra Day",
    "Revision-1",
    45,
    481.2,
    "gc_user2",
    "Pending",
  ],
  [
    "SunPower Energy Pvt. Ltd.",
    "SP-Unit-02 (50 MW)",
    "CTR-2026-018",
    "MSEDCL",
    "Day Ahead",
    "Revision-3",
    50,
    1060.9,
    "gc_user1",
    "Approved",
  ],
].map((row, index) => ({
  id: index + 1,
  company: row[0] as string,
  unit: row[1] as string,
  contract: row[2] as string,
  consumer: row[3] as string,
  scheduleType: row[4] as string,
  scheduleDate: "2026-08-07",
  revision: row[5] as string,
  capacity: row[6] as number,
  energy: row[7] as number,
  submittedOn: `07-Aug-2026 10:${String(15 + index * 5).padStart(2, "0")}`,
  submittedBy: row[8] as string,
  status: row[9] as ApprovalStatus,
}));

@Component({
  selector: "app-qca-schedule-approval",
  standalone: true,
  imports: [DatePipe, DecimalPipe],
  templateUrl: "./qca-schedule-approval.component.html",
  styleUrls: ["./qca-schedule-approval.component.scss"],
})
export class QcaScheduleApprovalComponent {
  readonly Math = Math;
  readonly submissions = signal(SUBMISSIONS);
  readonly qca = signal("Maharashtra Solar QCA (QCA-01)");
  readonly company = signal("All");
  readonly unit = signal("All");
  readonly contract = signal("All");
  readonly scheduleType = signal("All");
  readonly scheduleDate = signal("2026-08-07");
  readonly submissionDate = signal("");
  readonly status = signal<"All" | ApprovalStatus>("All");
  readonly applied = signal(false);
  readonly page = signal(1);
  readonly pageSize = 10;
  readonly selected = signal<Set<number>>(new Set());
  readonly pendingAction = signal<PendingAction | null>(null);

  constructor(private readonly router: Router) {}
  readonly filtered = computed(() => {
    if (!this.applied()) return this.submissions();
    return this.submissions().filter(
      (item) =>
        (this.company() === "All" || item.company === this.company()) &&
        (this.unit() === "All" || item.unit === this.unit()) &&
        (this.contract() === "All" || item.contract === this.contract()) &&
        (this.scheduleType() === "All" ||
          item.scheduleType === this.scheduleType()) &&
        (!this.scheduleDate() || item.scheduleDate === this.scheduleDate()) &&
        (this.status() === "All" || item.status === this.status()),
    );
  });
  
  readonly visibleRows = computed(() => {
    const start = (this.page() - 1) * this.pageSize;
    return this.filtered().slice(start, start + this.pageSize);
  });
  readonly totalPages = computed(() =>
    Math.max(1, Math.ceil(this.filtered().length / this.pageSize)),
  );
  readonly pageNumbers = computed(() =>
    Array.from({ length: this.totalPages() }, (_, index) => index + 1),
  );
  readonly pendingCount = computed(
    () => this.submissions().filter((item) => item.status === "Pending").length,
  );
  readonly approvedCount = computed(
    () =>
      this.submissions().filter((item) => item.status === "Approved").length,
  );
  readonly rejectedCount = computed(
    () =>
      this.submissions().filter((item) => item.status === "Rejected").length,
  );
  readonly totalCapacity = computed(() =>
    this.submissions().reduce((sum, item) => sum + item.capacity, 0),
  );
  readonly totalEnergy = computed(() =>
    this.submissions().reduce((sum, item) => sum + item.energy, 0),
  );
  readonly allVisibleSelected = computed(
    () =>
      this.visibleRows().length > 0 &&
      this.visibleRows().every((row) => this.selected().has(row.id)),
  );

  search(): void {
    this.applied.set(true);
    this.page.set(1);
  }
  reset(): void {
    this.company.set("All");
    this.unit.set("All");
    this.contract.set("All");
    this.scheduleType.set("All");
    this.scheduleDate.set("2026-08-07");
    this.submissionDate.set("");
    this.status.set("All");
    this.applied.set(false);
    this.page.set(1);
  }
  setStatus(id: number, status: ApprovalStatus): void {
    this.submissions.update((items) =>
      items.map((item) => (item.id === id ? { ...item, status } : item)),
    );
  }
  requestStatusChange(ids: number[], status: "Approved" | "Rejected"): void {
    if (ids.length) this.pendingAction.set({ ids, status });
  }
  confirmStatusChange(): void {
    const action = this.pendingAction();
    if (!action) return;
    const ids = new Set(action.ids);
    this.submissions.update((items) =>
      items.map((item) =>
        ids.has(item.id) && item.status === "Pending"
          ? { ...item, status: action.status }
          : item,
      ),
    );
    this.selected.set(new Set());
    this.pendingAction.set(null);
  }
  cancelStatusChange(): void { this.pendingAction.set(null); }
  setSelectedStatus(status: ApprovalStatus): void {
    if (status === "Approved" || status === "Rejected") {
      this.requestStatusChange([...this.selected()], status);
    }
  }
  toggle(id: number, checked: boolean): void {
    this.selected.update((current) => {
      const next = new Set(current);
      checked ? next.add(id) : next.delete(id);
      return next;
    });
  }
  toggleVisible(checked: boolean): void {
    this.visibleRows().forEach((row) => this.toggle(row.id, checked));
  }
  changePage(page: number): void {
    if (page >= 1 && page <= this.totalPages()) this.page.set(page);
  }
  exportCsv(): void {
    const heading =
      "#,Generating Company,Generating Unit,Contract No.,Schedule Type,Schedule Date,Revision,Capacity (MW),Energy (MWh),Status";
    const rows = this.filtered().map((item) =>
      [
        item.id,
        item.company,
        item.unit,
        item.contract,
        item.scheduleType,
        item.scheduleDate,
        item.revision,
        item.capacity,
        item.energy,
        item.status,
      ]
        .map((value) => `\"${String(value).replaceAll('\"', '\"\"')}\"`)
        .join(","),
    );
    const link = document.createElement("a");
    link.href = URL.createObjectURL(
      new Blob([[heading, ...rows].join("\n")], { type: "text/csv" }),
    );
    link.download = "qca-schedule-approvals.csv";
    link.click();
    URL.revokeObjectURL(link.href);
  }

  viewDetails(id: number): void {
   this.router.navigateByUrl("/view-schedule");
  }
}
